import { connect } from "react-redux";
import { getCategoryChildLinks } from "../../../state/modules/category";
import CategoryHeaderLinks from "./CategoryHeaderLinks";

const mapStateToProps = state => ({
  childLinks: getCategoryChildLinks(state)
});

export default connect(mapStateToProps)(CategoryHeaderLinks);
